export class PeerAnalysis {
  public product_id: number = null;

  public name: string = null;
  public creation_date: Date = null;
  public inception_date: Date = null;
  public last_date: Date = null;

  public returns: number = null;
  public volatility: number = null;
  public sharpe_ratio: number = null;
  public maximum_drawdown: number = null;
  public excess_returns: number = null;
  public tracking_error: number = null;
  public information_ratio: number = null;
  public maximum_relative_drawdown: number = null;

  public market_exposure: number = null;
  public factor_intensity: number = null;
  public effective_nb_of_factors: number = null;
  public effective_nb_of_factor_bets: number = null;
  public factor_deconcentration_quality: number = null;
  public factor_deconcentration_quality_rating: number = null;
  public factor_diversification_quality: number = null;
  public factor_diversification_quality_rating: number = null;

  public factor_betas_stability: number = null;
  public factor_intensity_stability: number = null;
  public factor_stability_rating: number = null;

  public conditional_performance: number = null;
  public conditional_performance_rating: number = null;

  public robust_risk_adjusted_performance_pvalue: number = null;
  public robust_risk_adjusted_performance_rating: number = null;

  public worst_5pct_rolling_volatility: number = null;
  public worst_5pct_rolling_tracking_error: number = null;
  public worst_rolling_risk_statistics_rating: number = null;

  public outperformance_probability_benchmark_rolling_1y: number = null;
  public outperformance_probability_benchmark_rolling_3y: number = null;
  public outperformance_probability_benchmark_rolling_5y: number = null;
  public outperformance_probability_risk_free_rolling_1y: number = null;
  public outperformance_probability_risk_free_rolling_3y: number = null;
  public outperformance_probability_risk_free_rolling_5y: number = null;

  public outperformance_probability_rating: number = null;
  public global_robustness_rating: number = null;

  constructor() {}

  // initialize current portfolio from JS object
  initFromData(data: any) {
    if (data==undefined) {return}

    this.creation_date  = data.creation_date ? new Date(data.creation_date) : this.creation_date;
    this.inception_date = data.inception_date ? new Date(data.inception_date) : this.inception_date;
    this.last_date      = data.last_date ? new Date(data.last_date) : this.last_date;
    delete data.creation_date;
    delete data.inception_date;
    delete data.last_date;

    Object.keys(data).forEach(key => {
      if (Object.keys(this).includes(key)) {
        this[key] = data[key];
      }
    });
  }
}
